/* 컬렉션 — collection 페이지에서만 로드 */

function initPromoDots(track) {
  const dots = track.parentElement.querySelector('[data-promo-dots]');
  if (!dots || track.dataset.dotsReady === 'true') return;

  track.dataset.dotsReady = 'true';

  const count = track.children.length;
  if (count < 2) return;

  let timer = null;
  let self = false;
  let settle = null;

  /* 양옆에 한 벌씩 복제해 두고 경계에서 위치를 순간이동시킨다.
     그래야 마지막에서 스와이프로 계속 넘길 수 있다 */
  const originals = Array.from(track.children);
  const before = document.createDocumentFragment();
  const after = document.createDocumentFragment();

  originals.forEach((item) => {
    [before, after].forEach((slot) => {
      const clone = item.cloneNode(true);
      clone.dataset.clone = '1';
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      slot.appendChild(clone);
    });
  });

  track.insertBefore(before, track.firstChild);
  track.appendChild(after);

  function stop() {
    if (!timer) return;
    clearInterval(timer);
    timer = null;
  }

  function stepWidth() {
    const first = track.children[0];
    const second = track.children[1];
    if (!first) return 0;

    /* 간격까지 포함한 한 칸 폭 */
    return second ? second.offsetLeft - first.offsetLeft : first.offsetWidth;
  }

  function loopable() {
    return track.scrollWidth > track.clientWidth + 1;
  }

  function currentIndex() {
    const step = stepWidth();
    if (!step) return 0;

    const raw = Math.round(track.scrollLeft / step);
    return ((raw % count) + count) % count;
  }

  function jump(to) {
    /* 우리가 옮기는 것이다. 사용자 스크롤로 오인해 자동 넘김을 끄면 안 된다 */
    self = true;
    if (settle) clearTimeout(settle);
    settle = setTimeout(() => { self = false; }, 250);

    track.classList.add('is-jumping');

    const prev = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = to;
    track.style.scrollBehavior = prev;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => track.classList.remove('is-jumping'));
    });
  }

  /* 복제 구간으로 넘어가면 같은 그림의 원본 자리로 되돌린다 */
  function normalize() {
    if (!loopable()) return;

    const span = stepWidth() * count;
    if (!span) return;

    if (track.scrollLeft < span - 1) jump(track.scrollLeft + span);
    else if (track.scrollLeft >= span * 2 - 1) jump(track.scrollLeft - span);
  }

  function goTo(index) {
    const positions = [index, count + index, count * 2 + index]
      .map((i) => track.children[i])
      .filter(Boolean)
      .map((el) => el.offsetLeft - track.offsetLeft);

    if (!positions.length) return;

    /* 지금 위치에서 가장 가까운 복제본으로 간다 */
    let target = positions[0];
    positions.forEach((left) => {
      if (Math.abs(left - track.scrollLeft) < Math.abs(target - track.scrollLeft)) target = left;
    });

    self = true;
    if (settle) clearTimeout(settle);

    track.scrollTo({ left: target, behavior: 'smooth' });

    /* 스크롤 이벤트가 아예 안 오는 경우를 대비한 보험 */
    settle = setTimeout(() => { self = false; }, 1200);
  }

  for (let index = 0; index < count; index += 1) {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'collection-promo__dot';
    dot.setAttribute('aria-label', String(index + 1));

    dot.addEventListener('click', () => {
      stop();
      goTo(index);
    });

    dots.appendChild(dot);
  }

  const buttons = Array.from(dots.children);
  let ticking = false;
  let idle = null;

  function paint() {
    if (!stepWidth()) return;

    const index = currentIndex();

    /* 왼쪽에서 오른쪽으로 채워지는 폭 */
    dots.style.setProperty('--promo-fill', ((index + 1) / count) * 100 + '%');
    buttons.forEach((button, i) => button.classList.toggle('is-active', i === index));
  }

  function start() {
    if (!loopable()) return;
    jump(stepWidth() * count);
    paint();
  }

  track.addEventListener('scroll', () => {
    if (self) {
      if (settle) clearTimeout(settle);
      settle = setTimeout(() => { self = false; }, 150);
    } else {
      stop();
    }

    /* 스크롤이 멎은 뒤에만 자리를 옮긴다. 넘기는 도중에 옮기면 손끝에서 삐끗한다 */
    if (idle) clearTimeout(idle);
    idle = setTimeout(normalize, 140);

    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      ticking = false;
      paint();
    });
  }, { passive: true });

  window.addEventListener('resize', () => {
    normalize();
    paint();
  });

  /* 손대면 자동 넘김을 멈춘다 */
  ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((type) => {
    track.addEventListener(type, stop, { passive: true });
  });

  const seconds = parseFloat(dots.dataset.promoAutoplay);

  if (seconds > 0) {
    timer = setInterval(() => {
      goTo((currentIndex() + 1) % count);
    }, seconds * 1000);
  }

  requestAnimationFrame(start);
}

/* LNB 가 헤더 밑에 붙었는지 본다. 붙으면 경로 줄이 낮아진다 —
   CSS 만으로는 "붙은 상태"를 알 수 없다.
   같은 김에 헤더도 내릴 때 숨기고 올릴 때 다시 보이게 한다.
   테마 설정의 hide_on_scroll 은 전 페이지에 걸려서 여기서만 흉내낸다 */
function initTabsStuck() {
  const section = document.querySelector('.shopify-section--collection-tabs');
  if (!section || section.dataset.stuckReady === 'true') return;

  section.dataset.stuckReady = 'true';

  const header = document.querySelector('.header');
  const themeHandles = header && header.closest('[hide-on-scroll]');

  let waiting = false;
  let lastY = Math.max(0, window.scrollY);
  let hidden = false;

  const setHeader = (next) => {
    if (next === hidden || !header || themeHandles) return;

    /* 메뉴나 검색이 열려 있으면 건드리지 않는다 */
    if (next && header.querySelectorAll('[open]').length > 0) return;

    hidden = next;
    header.classList.toggle('is-hidden', next);
    document.documentElement.style.setProperty('--header-is-visible', next ? '0' : '1');
  };

  const paint = () => {
    const y = Math.max(0, window.scrollY);

    /* 내릴 때는 100 이상 움직여야 숨긴다. 올릴 때는 바로 보인다 */
    if (y > lastY && y - lastY > 100) {
      setHeader(true);
      lastY = y;
    } else if (y < lastY) {
      setHeader(false);
      lastY = y;
    }

    const top = parseFloat(getComputedStyle(section).insetBlockStart) || 0;
    section.classList.toggle('is-stuck', section.getBoundingClientRect().top <= top + 1);
  };

  window.addEventListener('scroll', () => {
    if (waiting) return;
    waiting = true;

    requestAnimationFrame(() => {
      waiting = false;
      paint();
    });
  }, { passive: true });

  window.addEventListener('resize', paint);
  paint();
}

function init(scope) {
  (scope || document).querySelectorAll('[data-promo-carousel]').forEach(initPromoDots);
  initTabsStuck();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init());
} else {
  init();
}

document.addEventListener('shopify:section:load', (event) => init(event.target));
